import React from 'react'
import { IonCard, IonItemDivider, IonLabel } from '@ionic/react'
import { useTranslation } from 'react-i18next'
import useDeviceMetrics from '../../../utilities/useDeviceMetrics'
import AllergiesButtons from '../page/AllergiesButtons/AllergiesButtons.component'

const PatientAllergiesContent: React.FC = () => {
  const { t } = useTranslation()
  const { isTablet: isTabletDevice } = useDeviceMetrics()

  return (
    <>
      <IonItemDivider color='light' className={isTabletDevice ? 'ion-padding divider-padding' : 'ion-hide-sm-down'}>
        <IonLabel className='grid-item-divider-label' color='medium'>
          {t('patientAllergies.PatientAllergiesDetails')}
        </IonLabel>
      </IonItemDivider>
      <IonCard className={isTabletDevice ? 'card-width' : 'card-margin'}>
        <AllergiesButtons />
      </IonCard>
    </>
  )
}

export default PatientAllergiesContent
